// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5z-6";
export var headerCell = "_5z-2";
export var rowWrapper = "_5z-4";
export var stickyAggregationCell = "_5z-a";
export var stickyAggregationRow = "_5z-7";
export var stickyColumnCell = "_5z-9";
export var stickyColumnHeaderCell = "_5z-8";
export var table = "_5z-1";
export var virtualRowWrapper = "_5z-5";
export var virtualTableContainer = "_5z-0";
export var white = "_5z-3";